import { render, staticRenderFns } from "./CustomerOrderTable.vue?vue&type=template&id=535d7880&scoped=true"
import script from "./CustomerOrderTable.vue?vue&type=script&lang=js"
export * from "./CustomerOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d7880",
  null
  
)

export default component.exports